// SfPlanningRecordType[0] is the name on the server and SfPlanningRecordType[1] is the display
// name on the UI. This is a subset of all available values.
export const SfPlanningRecordType = {
    'Affordable Housing Bonus (AHB)': 'Affordable Housing Bonus',
    'Certificate of Appropriateness (COA)': 'Cert. of Appropriateness',
    'Certificate of Transfer-TDR (TDT)': 'Cert. of Transfer-TDR',
    'Coastal Zone Permit (CTZ)': 'Coastal Zone Permit',
    'Conditional Use Authorization (CUA)': 'Conditional Use',
    'Discretionary Review - Mandatory (DRM)': 'Discretionary Review - Mandatory',
    'Discretionary Review - Public Initiated (DRP)': 'Discretionary Review - Public Initiated',
    'Development Agreements-LEG (DVA)': 'Development Agreements-LEG',
    'Enforcement (ENF)': 'Enforcement',
    'Environmental (ENV)': 'Environmental Eval.',
    'General Plan Amendment-LEG (GPA)': 'General Plan Amendment-LEG',
    'General Plan Referral (GPR)': 'General Plan Referral',
    'Historic Resource Review (HRR)': 'Historic Resource Review',
    'Zoning Map Amendment-LEG (MAP)': 'Zoning Map Amendment-LEG',
    'Plan Code Amendment-LEG (PCA)': 'Plan Code Amendment-LEG',
    'Project Review Meetings (PRV)': 'Project Review Meetings',
    'Shadow Study (SHD)': 'Shadow Study',
    'Subdivision-REF (SUB)': 'Subdivision-REF',
    'Statement of Eligibility-TDR (TDE)': 'Statement of Eligibility-TDR',
    'Temporary Use Authorization (TUA)': 'Temporary Use Authorization',
    'Transportation Demand Management (TDM)': 'Transportation Demand Management',
    'Variance (VAR)': 'Variance',
    'Zoning Administrator Determination Letter (ZAD)': 'Zoning Determination Letter',

    // CRV: 'Commission Review (CRV)',
    // CWP: 'Citywide Planning (CWP)',
    // DES: 'Designations (DES)',
    // DNX: 'Downtown Exception-309 (DNX)',
    // ENX: 'Eastern Neighborhoods Exception-329 (ENX)',
    // FED: 'Federal Section 106 (FED)',
    // IMP: 'Institutional Master Plan (IMP)',
    // LLA: 'Lot Line Adjustments-REF (LLA)',
    // MCM: 'Monitoring Conditions and Mitigation Measures (MCM)',
    // OFA: 'Office Allocation-321 (OFA)',
    // PPA: 'Preliminary Project Assessment (PPA)',
    // PPS: 'Preliminary Project Submittal (PPS)',
    // PRJ: 'Project Profile (PRJ)',
    // PTA: 'Permit to Alter Major/Minor (PTA)',
    // APL: 'Appeals (APL)',
    // CND: 'Condo-REF (CND)',
    // ZAV: 'Zoning Administrator Verification Letter (ZAV)',
}

export const SfPlanningFileType = {
    'Application':     'Application',
    'Coastal Permit Authorizations' :     'Coastal Permit Authorizations',
    'Motions-Executive-Summary':     'Comm. Motions & Executive Summaries',
    'DR Action Memos':     'Discretionary Reviews',
    'General Plan Referral Findings':     'General Plan Findings',
    'Legislation and Ordinances':     'Legislation & Ordinances',
    'Notices of Violation and Penalty':     'Notices of Violation/Penalty',
    'Staff Reports':     'Other Staff Reports',
    'Photos':     'Photos',
    'Plans':     'Plans',
    'PPA Letters':     'Prem. Proj Assessment',
    'Preservation Review':     'Preservation/Historic Review',
    'Shadow Study':     'Shadow Study',
    'Variance Decision Letters':     'Variance Determination',
    'Letters of Determination':     'Zoning Determination',

    // 'Zoning Verification Letters': 'Zoning Verification Letters',
    // 'Correspondence': 'Correspondence',
    // 'Notification': 'Notification',
    // 'CPC Motions and Resolutions': 'CPC Motions and Resolutions',
    // 'Document': 'Document',
    // 'Executive Summary': 'Executive Summary',
    // 'Exhibits Report': 'Exhibits Report',
    // 'Graphics': 'Graphics',
    // 'HPC Motions and Resolutions': 'HPC Motions and Resolutions',
    // 'Map': 'Map',
    // 'Minor Permit to Alter': 'Minor Permit to Alter',
    // 'Miscellaneous Permit Responses': 'Miscellaneous Permit Responses',
    // 'Other document': 'Other document',
    // 'Other': 'Other',
    // 'Permit to Alter': 'Permit to Alter',
    // 'Public Info Requests': 'Public Info Requests',    
    // 'Working Document': 'Working Document',
    // 'ZA Action Memos': 'ZA Action Memos',
}

export const SfFilterFileTypes = {
    'Coastal Permit Authorizations' :     'Coastal Permit Auth.',
    'Motions-Executive-Summary': 'Commission Motions / Executive Summaries',
    'DR Action Memos':     'Discretionary Reviews',
    'General Plan Referral Findings':     'General Plan Findings',
    'Legislation and Ordinances':     'Legislation & Ordinances',
    // 'Notices of Violation and Penalty':     'Violations / Penalties',
    'Staff Reports':     'Misc. Staff Reports',
    // 'Photos':     'Photos',
    'Plans':     'Plans',
    // 'PPA Letters':     'Prem. Proj Assessment',
    'Preservation Review':     'Preservation Reviews',
    'Variance Decision Letters':     'Variance Determination',
    'Letters of Determination':     'Zoning Admin Determination',
    'Violations-Penalty': 'Violations / Penalties',
}

export const SfAllUses = {
    'ENTERTAINMENT, ARTS AND RECREATION': 'Entertainment, Arts and Recreation',
    'ARTS ACTIVITIES': 'Arts Activities',
    'ENTERTAINMENT, GENERAL': 'Entertainment, General',
    'ENTERTAINMENT, NIGHTTIME': 'Entertainment, Nighttime',
    'LIVERY STABLE': 'Livery Stable',
    'MOVIE THEATER': 'Movie Theater',
    'ENTERTAINMENT, OUTDOOR': 'Entertainment, Outdoor',
    'SPORTS STADIUM': 'Sports Stadium',
    'NON-COMMERCIAL ENTERTAINMENT AND RECREATION': 'Non-Commercial Entertainment and Recreation',
    'PASSIVE OUTDOOR RECREATION': 'Passive Outdoor Recreation',
    'OPEN RECREATION AREA': 'Open Recreation Area',
    'UTILITY AND INFRASTRUCTURE': 'Utility and Infrastructure',
    'COMMUNITY RECYCLING COLLECTION CENTER': 'Community Recycling Collection Center',
    'INTERNET SERVICE EXCHANGE': 'Internet Service Exchange',
    'POWER PLANT': 'Power Plant',
    'PUBLIC TRANSPORTATION FACILITY': 'Public Transportation Facility',
    'PUBLIC UTILITIES YARD': 'Public Utilities Yard',
    'WIRELESS TELECOMMUNICATIONS SERVICES (WTS) FACILITY': 'Wireless Telecommunications Services (WTS) Facility',
    'UTILITY INSTALLATION': 'Utility Installation',
    'INSTITUTIONAL': 'Institutional',
    'INSTITUTIONAL COMMUNITY': 'Institutional Community',
    'INSTITUTIONAL EDUCATION': 'Institutional Education',
    'INSTITUTIONAL HEALTHCARE': 'Institutional Healthcare',
    'CHILD CARE FACILITY': 'Child Care Facility',
    'COMMUNITY FACILITY': 'Community Facility',
    'COMMUNITY FACILITY, PRIVATE': 'Community Facility, Private',
    'RELIGIOUS INSTITUTION': 'Religious Institution',
    'JOB TRAINING': 'Job Training',
    'SOCIAL SERVICE OR PHILANTHROPIC FACILITY': 'Social Service or Philanthropic Facility',
    'PUBLIC FACILITY': 'Public Facility',
    'POST-SECONDARY EDUCATIONAL INSTITUTION': 'Post-Secondary Educational Institution',
    'SCHOOL': 'School',
    'TRADE SCHOOL': 'Trade School',
    'HOSPITAL': 'Hospital',
    'MEDICAL CANNABIS DISPENSARY': 'Medical Cannabis Dispensary',
    'RESIDENTIAL CARE FACILITY': 'Residential Care Facility',
    'RESIDENTIAL': 'Residential',
    'DWELLING UNIT': 'Dwelling Unit',
    'GROUP HOUSING': 'Group Housing',
    'RESIDENTIAL HOTEL': 'Residential Hotel',
    'SENIOR HOUSING': 'Senior Housing',
    'HOMELESS SHELTER': 'Homeless Shelter',
    'LIVE/WORK UNIT': 'Live/Work Unit',
    'COMMERCIAL': 'Commercial',
    'RETAIL ENTERTAINMENT': 'Retail Entertainment',
    'AGRICULTURE': 'Agriculture',
    'INDUSTRIAL': 'Industrial',
    'RETAIL': 'Retail',
    'NON-RETAIL': 'Non-Retail',
    'SALES AND SERVICES': 'Sales and Services',
    'AUTOMOTIVE': 'Automotive',
    'AGRICULTURE, INDUSTRIAL': 'Agriculture, Industrial',
    'AGRICULTURE, URBAN': 'Agriculture, Urban',
    'AGRICULTURE, NEIGHBORHOOD': 'Agriculture, Neighborhood',
    'AGRICULTURE, LARGE-SCALE URBAN': 'Agriculture, Large-Scale Urban',
    'AGRICULTURAL AND BEVERAGE PROCESSING 1': 'Agricultural and Beverage Processing 1',
    'AGRICULTURAL AND BEVERAGE PROCESSING 2': 'Agricultural and Beverage Processing 2',
    'AUTOMOBILE WRECKING': 'Automobile Wrecking',
    'AUTOMOBILE ASSEMBLY': 'Automobile Assembly',
    'GRAIN ELEVATOR': 'Grain Elevator',
    'HAZARDOUS WASTE FACILITY': 'Hazardous Waste Facility',
    'JUNK YARD': 'Junk Yard',
    'LIVESTOCK PROCESSING 1': 'Livestock Processing 1',
    'LIVESTOCK PROCESSING 2': 'Livestock Processing 2',
    'MANUFACTURING 1, HEAVY': 'Manufacturing 1, Heavy',
    'MANUFACTURING 2, HEAVY': 'Manufacturing 2, Heavy',
    'MANUFACTURING 3, HEAVY': 'Manufacturing 3, Heavy',
    'MANUFACTURING, LIGHT': 'Manufacturing, Light',
    'METAL WORKING': 'Metal Working',
    'STORAGE YARD': 'Storage Yard',
    'STORAGE, VOLATILE MATERIALS': 'Storage, Volatile Materials',
    'TRUCK TERMINAL': 'Truck Terminal',
    'SHIPYARD': 'Shipyard',
    'SALES AND SERVICES, RETAIL': 'Sales and Services, Retail',
    'AUTOMOTIVE, RETAIL': 'Automotive, Retail',
    'AUTOMOTIVE, NON-RETAIL': 'Automotive, Non-Retail',
    'SALES AND SERVICES, NON-RETAIL': 'Sales and Services, Non-Retail',
    'RETAIL WORKSPACE': 'Retail Workspace',
    'REPRODUCTIVE HEALTH CLINIC': 'Reproductive Health Clinic',
    'FLEXIBLE RETAIL': 'Flexible Retail',
    'FLEXIBLE WORKSPACE': 'Flexible Workspace',
    'ADULT BUSINESS': 'Adult Business',
    'ADULT SEX VENUE': 'Adult Sex Venue',
    'ANIMAL HOSPITAL': 'Animal Hospital',
    'CANNABIS RETAIL': 'Cannabis Retail',
    'MASSAGE, CHAIR/FOOT': 'Massage, Chair/Foot',
    'GIFT STORE-TOURIST ORIENTED': 'Gift Store-Tourist Oriented',
    'GROCERY, GENERAL': 'Grocery, General',
    'GROCERY, SPECIALTY': 'Grocery, Specialty',
    'GYM': 'Gym',
    'HOTEL': 'Hotel',
    'JEWELRY STORE': 'Jewelry Store',
    'KENNEL': 'Kennel',
    'LAUNDROMAT': 'Laundromat',
    'LIQUOR STORE': 'Liquor Store',
    'MASSAGE ESTABLISHMENT': 'Massage Establishment',
    'MORTUARY': 'Mortuary',
    'MOTEL': 'Motel',
    'PHARMACY': 'Pharmacy',
    'RETAIL SALES AND SERVICE, GENERAL': 'Retail Sales and Service, General',
    'SERVICE, FINANCIAL': 'Service, Financial',
    'SERVICE, FRINGE FINANCIAL': 'Service, Fringe Financial',
    'SERVICE, LIMITED FINANCIAL': 'Service, Limited Financial',
    'SERVICE, HEALTH': 'Service, Health',
    'SERVICE, PERSONAL': 'Service, Personal',
    'SERVICE, RETAIL PROFESSIONAL': 'Service, Retail Professional',
    'STORAGE, SELF': 'Storage, Self',
    'TOBACCO PARAPHERNALIA ESTABLISHMENT': 'Tobacco Paraphernalia Establishment',
    'TRADE SHOP': 'Trade Shop',
    'NON-AUTO VEHICLE SALES OR RENTAL': 'Non-Auto Vehicle Sales or Rental',
    'EATING AND DRINKING': 'Eating and Drinking',
    'BAR': 'Bar',
    'RESTAURANT': 'Restaurant',
    'LIMITED RESTAURANT': 'Limited Restaurant',
    'SERVICE, BUSINESS': 'Service, Business',
    'CATERING': 'Catering',
    'STORAGE, COMMERCIAL': 'Storage, Commercial',
    'DESIGN PROFESSIONAL': 'Design Professional',
    'OFFICE, GENERAL': 'Office, General',
    'LABORATORY': 'Laboratory',
    'LIFE SCIENCE': 'Life Science',
    'SERVICE, NON-RETAIL PROFESSIONAL': 'Service, Non-Retail Professional',
    'TRADE OFFICE': 'Trade Office',
    'WHOLESALE SALES': 'Wholesale Sales',
    'STORAGE, WHOLESALE': 'Storage, Wholesale',
    'AUTOMOTIVE REPAIR': 'Automotive Repair',
    'AUTOMOBILE SALE OR RENTAL': 'Automobile Sale or Rental',
    'AUTOMOTIVE SERVICE STATION': 'Automotive Service Station',
    'AUTOMOTIVE WASH': 'Automotive Wash',
    'ELECTRIC VEHICLE CHARGING LOCATION': 'Electric Vehicle Charging Location',
    'GAS STATION': 'Gas Station',
    'PARKING GARAGE, PUBLIC': 'Parking Garage, Public',
    'PARKING LOT, PUBLIC': 'Parking Lot, Public',
    'VEHICLE STORAGE GARAGE': 'Vehicle Storage Garage',
    'VEHICLE STORAGE LOT': 'Vehicle Storage Lot',
    'AMBULANCE SERVICE': 'Ambulance Service',
    'FLEET CHARGING': 'Fleet Charging',
    'SERVICE, PARCEL DELIVERY': 'Service, Parcel Delivery',
    'PARKING GARAGE, PRIVATE': 'Parking Garage, Private',
    'PARKING LOT, PRIVATE': 'Parking Lot, Private',
    'SERVICE, MOTOR VEHICLE TOW': 'Service, Motor Vehicle Tow',
    'OFFICE': 'Office',
    'NON-RESIDENTIAL': 'Non-Residential',
    'PRODUCTION, DISTRIBUTION, AND REPAIR (PDR)': 'Production, Distribution, and Repair (PDR)',
    'SMALL ENTERPRISE WORKSPACE (S.E.W.)': 'Small Enterprise Workspace (S.E.W.)',
}

export const IntToString = {
    0: 'No',
    1: 'Yes',
}

export const SfEnvironmentFileType = {
    'Community Plan Evaluation': 'Community Plan Evaluation',
    'Environmental Impact Report': 'Environmental Impact Report',
    'Mitigating Negative Impact': 'Mitigating Negative Impact',
    'Environmental Monitoring': 'Environmental Monitoring',
    'Historic Resource Evaluation Review': 'Historic Resource Evaluation Review',
}

export const SfPlanningFileTypeAdmin = {
    'Application': 'Application',
    'Board of Appeals Decisions': 'Board of Appeals Decisions',
    'Coastal Permit Authorizations': 'Coastal Permit Authorizations',
    'Commission Submittal': 'Commission Submittal',
    'Correspondence': 'Correspondence',
    'CPC Motions and Resolutions': 'CPC Motions and Resolutions',
    'Document': 'Document',
    // 'DR Action Memos': 'DR Action Memos',
    'Environmental Analysis': 'Environmental Analysis',
    'Environmental Monitoring': 'Environmental Monitoring',
    'Executive Summary': 'Executive Summary',
    'Exhibits Report': 'Exhibits Report',
    'General Plan Referral Findings': 'General Plan Referral Findings',
    'Graphics': 'Graphics',
    'HPC Motions and Resolutions': 'HPC Motions and Resolutions',
    // 'Legislation and Ordinances': 'Legislation and Ordinances',
    'Letters of Determination': 'Letters of Determination',
    'Map': 'Map',
    'Minor Permit to Alter': 'Minor Permit to Alter',
    'Miscellaneous Permit Responses': 'Miscellaneous Permit Responses',
    'Notice of Special Restrictions': 'Notice of Special Restrictions',
    // 'Notices of Violation and Penalty': 'Notices of Violation and Penalty',
    'Notification': 'Notification',
    'Other document': 'Other document',
    'Other': 'Other',
    'Permit to Alter': 'Permit to Alter',
    'Photos': 'Photos',
    'Planning Approval Letter': 'Planning Approval Letter',
    'Plans': 'Plans',
    // 'PPA Letters': 'PPA Letters',
    'Preservation Review': 'Preservation Review',
    // 'Public Info Requests': 'Public Info Requests',
    'Shadow Study': 'Shadow Study',
    'Staff Reports': 'Staff Reports',
    'Technical Reports': 'Technical Reports',
    'Variance Decision Letters': 'Variance Decision Letters',
    // 'Working Document': 'Working Document',
    'ZA Action Memos': 'ZA Action Memos',
    'ZA Letters Other': 'ZA Letters Other',
    'Zoning Verification Letters': 'Zoning Verification Letters',

    'Other Planning Staff Document': 'Other Planning Staff Document',
    'Commission Submittal - Client': 'Commission Submittal - Client',

    'Community Plan Evaluation': 'Community Plan Evaluation',
    'Environmental Impact Report': 'Environmental Impact Report',
    'Mitigating Negative Impact': 'Mitigating Negative Impact',
    'Historic Resource Evaluation Review': 'Historic Resource Evaluation Review',
    'Historic Resource Review': 'Historic Resource Review',
    'Opposition Letter': 'Opposition Letter',
    'Notice of Complaint': 'Notice of Complaint',
    'Notice of Violation': 'Notice of Violation',
    'Notice of Enforcement': 'Notice of Enforcement',
    'Notices of Violation and Penalty': 'Notices of Violation and Penalty',
}

export const SfUseDistrict = {
    'C-2': 'C-2',
    'C-3-G': 'C-3-G',
    'C-3-O': 'C-3-O',
    'C-3-O(SD)': 'C-3-O(SD)',
    'C-3-R': 'C-3-R',
    'C-3-S': 'C-3-S',
    'CCB': 'CCB',
    'CMUO': 'CMUO',
    'CRNC': 'CRNC',
    'CVR': 'CVR',
    'HP-RA': 'HP-RA',
    'M-1': 'M-1',
    'M-2': 'M-2',
    'MB-RA': 'MB-RA',
    'MUG': 'MUG',
    'MUO': 'MUO',
    'MUR': 'MUR',
    'NC-1': 'NC-1',
    'NC-2': 'NC-2',
    'NC-3': 'NC-3',
    'NC-S': 'NC-S',
    'NCD-24TH-NOE-VALLEY': 'NCD-24TH-NOE-VALLEY',
    'NCD-CASTRO': 'NCD-CASTRO',
    'NCD-CORTLAND AVENUE': 'NCD-CORTLAND AVENUE',
    'NCD-EXCELSIOR': 'NCD-EXCELSIOR',
    'NCD-GEARY BOULEVARD': 'NCD-GEARY BOULEVARD',
    'NCD-HAIGHT': 'NCD-HAIGHT',
    'NCD-INNER BALBOA STREET': 'NCD-INNER BALBOA STREET',
    'NCD-INNER CLEMENT': 'NCD-INNER CLEMENT',
    'NCD-INNER SUNSET': 'NCD-INNER SUNSET',
    'NCD-INNER TARAVAL STREET': 'NCD-INNER TARAVAL STREET',
    'NCD-IRVING': 'NCD-IRVING',
    'NCD-JAPANTOWN': 'NCD-JAPANTOWN',
    'NCD-LAKESIDE VILLAGE': 'NCD-LAKESIDE VILLAGE',
    'NCD-LOWER POLK STREET': 'NCD-LOWER POLK STREET',
    'NCD-MISSION BERNAL': 'NCD-MISSION BERNAL',
    'NCD-NORIEGA': 'NCD-NORIEGA',
    'NCD-NORTH BEACH': 'NCD-NORTH BEACH',
    'NCD-OUTER CLEMENT': 'NCD-OUTER CLEMENT',
    'NCD-POLK': 'NCD-POLK',
    'NCD-SAN BRUNO AVENUE': 'NCD-SAN BRUNO AVENUE',
    'NCD-TARAVAL': 'NCD-TARAVAL',
    'NCD-UNION': 'NCD-UNION',
    'NCD-WEST PORTAL': 'NCD-WEST PORTAL',
    'NCT-2': 'NCT-2',
    'NCT-3': 'NCT-3',
    'NCT-DIVISADERO': 'NCT-DIVISADERO',
    'NCT-FILLMORE': 'NCT-FILLMORE',
    'NCT-GLEN PARK': 'NCT-GLEN PARK',
    'NCT-HAYES': 'NCT-HAYES',
    'NCT-MISSION': 'NCT-MISSION',
    'NCT-OCEAN': 'NCT-OCEAN',
    'NCT-UPPER MARKET': 'NCT-UPPER MARKET',
    'NCT-VALENCIA': 'NCT-VALENCIA',
    'P': 'P',
    'PDR-1-B': 'PDR-1-B',
    'PDR-1-D': 'PDR-1-D',
    'PDR-1-G': 'PDR-1-G',
    'PDR-2': 'PDR-2',
    'RC-3': 'RC-3',
    'RC-4': 'RC-4',
    'RCD': 'RCD',
    'RED': 'RED',
    'RH DTR': 'RH DTR',
    'RH-1': 'RH-1',
    'RH-1(D)': 'RH-1(D)',
    'RH-1(S)': 'RH-1(S)',
    'RH-2': 'RH-2',
    'RH-3': 'RH-3',
    'RM-1': 'RM-1',
    'RM-2': 'RM-2',
    'RM-3': 'RM-3',
    'RM-4': 'RM-4',
    'RTO-M': 'RTO-M',
    'RTO': 'RTO',
    'SALI': 'SALI',
    'UMU': 'UMU',
    'WMUG': 'WMUG',
    'WMUO': 'WMUO',
}

export const SfHeightDistrict = {
    '105-D': '105-D',
    '105-E': '105-E',
    '105-X': '105-X',
    '110-X': '110-X',
    '120-R-2': '120-R-2',
    '120-X': '120-X',
    '120/400-R-2 // 140/520-R-2': '120/400-R-2 // 140/520-R-2',
    '120/400-R-2': '120/400-R-2',
    '130-CS-200-CS': '130-CS-200-CS',
    '130-CS': '130-CS',
    '130-E': '130-E',
    '150-S': '150-S',
    '160-F': '160-F',
    '160-M': '160-M',
    '160-S': '160-S',
    '200-CS': '200-CS',
    '200-S': '200-S',
    '25-X': '25-X',
    '250-S': '250-S',
    '26-40-X': '26-40-X',
    '26-X': '26-X',
    '28-X': '28-X',
    '30-X': '30-X',
    '300-S': '300-S',
    '320-I': '320-I',
    '340-I': '340-I',
    '350-S': '350-S',
    '40-X': '40-X',
    '40/55-X': '40/55-X',
    '400-S': '400-S',
    '400-W': '400-W',
    '45-X': '45-X',
    '450-S': '450-S',
    '48-X': '48-X',
    '50-N': '50-N',
    '50-X': '50-X',
    '500-I': '500-I',
    '55-X': '55-X',
    '550-S': '550-S',
    '58-X': '58-X',
    '60/65-X': '60/65-X',
    '65-85-N': '65-85-N',
    '65-A': '65-A',
    '65-B': '65-B',
    '65-J': '65-J',
    '65-N': '65-N',
    '65-X': '65-X',
    '68-X': '68-X',
    '75-X': '75-X',
    '80-130-F': '80-130-F',
    '80-A': '80-A',
    '80-B': '80-B',
    '80-D': '80-D',
    '80-E': '80-E',
    '80-T-130-T': '80-T-130-T',
    '80-T': '80-T',
    '80-X': '80-X',
    '84-E': '84-E',
    '84-X': '84-X',
    '85-X': '85-X',
    '90-X': '90-X',
    'HP-RA': 'HP-RA',
    'MB-RA': 'MB-RA',
    'OS': 'OS',
}

export const SfSpecialUseDistrict = {
    '3rd St Alcohol Restrict': '3rd St Alcohol Restrict',
    '901 Bush Street SUD': '901 Bush Street SUD',
    'Art & Design Education': 'Art & Design Education',
    'Bayshore Blvd Home Improvement': 'Bayshore Blvd Home Improvement',
    'Bayshore Hester NC': 'Bayshore Hester NC',
    'Bayview Industrial Triangle Cannabis RUD': 'Bayview Industrial Triangle Cannabis RUD',
    'Bernal Heights': 'Bernal Heights',
    'Calle 24 SUD': 'Calle 24 SUD',
    'Central Neighborhoods Large Residence': 'Central Neighborhoods Large Residence',
    'Central SoMa': 'Central SoMa',
    'Chestnut St Fin Svcs Restrict': 'Chestnut St Fin Svcs Restrict',
    'Corona Heights Large Residence': 'Corona Heights Large Residence',
    'Design & Development': 'Design & Development',
    'Dolores Heights': 'Dolores Heights',
    'ELIMINATED: Industrial Protection Zone': 'ELIMINATED: Industrial Protection Zone',
    'Family and Senior Housing Opportunity SUD': 'Family and Senior Housing Opportunity SUD',
    'Folsom & Main Res Comm': 'Folsom & Main Res Comm',
    'Fringe Financial Services RUD': 'Fringe Financial Services RUD',
    'Geary Blvd Formula Retail Pet Supply Store and Formula Retail Eating and Drinking Subdistrict': 'Geary Blvd Formula Retail Pet Supply Store and Formula Retail Eating and Drinking Subdistrict',
    'Group Housing Special Use District': 'Group Housing Special Use District',
    'Haight Street Alcohol Restricted Use': 'Haight Street Alcohol Restricted Use',
    'India Basin Industrial Park': 'India Basin Industrial Park',
    'Innovative Industries': 'Innovative Industries',
    'Jackson Square': 'Jackson Square',
    'Japantown': 'Japantown',
    'Lakeshore Plaza NC': 'Lakeshore Plaza NC',
    'Lower Polk Street Alcohol Restricted Use': 'Lower Polk Street Alcohol Restricted Use',
    'Mission Alcohol Restrict': 'Mission Alcohol Restrict',
    'Mission Street Formula Retail Restaurant Subdistrict': 'Mission Street Formula Retail Restaurant Subdistrict',
    'North Beach Limited Financial': 'North Beach Limited Financial',
    'North Beach SUD': 'North Beach SUD',
    'North of Market Residential 1': 'North of Market Residential 1',
    'North of Market Residential 2': 'North of Market Residential 2',
    'Oceanview Large Residence': 'Oceanview Large Residence',
    'OLD: Ocean Ave Fast Food': 'OLD: Ocean Ave Fast Food',
    'Priority Equity Geographies SUD': 'Priority Equity Geographies SUD',
    'Taraval Street Restaurant Subdistrict': 'Taraval Street Restaurant Subdistrict',
    'Telegraph Hill-NB Residential': 'Telegraph Hill-NB Residential',
    'Third Street': 'Third Street',
    'Transbay C3': 'Transbay C3',
    'Transit Center C-3-O(SD) Commercial': 'Transit Center C-3-O(SD) Commercial',
    'Van Ness and Market Residential': 'Van Ness and Market Residential',
    'Van Ness Automotive': 'Van Ness Automotive',
    'Van Ness': 'Van Ness',
    'Washington-Broadway SUD': 'Washington-Broadway SUD',
    'Waterfront 2': 'Waterfront 2',
    'Waterfront 3': 'Waterfront 3',
    'Waterfront 4': 'Waterfront 4',
    'Western SoMa': 'Western SoMa',
    'Within 1/4 Mile of an Existing Fringe Financial Service': 'Within 1/4 Mile of an Existing Fringe Financial Service',
    'Within 1/4 Mile of the Fringe Financial Services RUD': 'Within 1/4 Mile of the Fringe Financial Services RUD',
    'Youth and Family Zone': 'Youth and Family Zone',
}

export const DistanceMile = [
    {value: "0", display: "Any distance"},
    {value: "0.125", display: "Within 1/8 mile"},
    {value: "0.25", display: "Within 1/4 mile"},
    {value: "0.5", display: "Within 1/2 mile"},
    {value: "0.75", display: "Within 3/4 mile"},
    {value: "1.0", display: "Within 1 mile"},
    {value: "1.25", display: "Within 1 1/4 miles"},
    {value: "1.5", display: "Within 1 1/2 miles"},
    {value: "1.75", display: "Within 1 3/4 miles"},
    {value: "2", display: "Within 2 miles"},
    {value: "2.5", display: "Within 2 1/2 miles"},
    {value: "3", display: "Within 3 miles"},
    {value: "3.5", display: "Within 3 1/2 miles"},
    {value: "4", display: "Within 4 miles"},
    {value: "4.5", display: "Within 4 1/2 miles"},
    {value: "5", display: "Within 5 miles"},
    {value: "5.5", display: "Within 5 1/2 miles"},
    {value: "6", display: "Within 6 miles"},
    {value: "6.5", display: "Within 6 1/2 miles"},
]

export const SfRecordStatus = {
    'Open': 'open',
    'Closed/completed': 'closed',
    'Canceled/incomplete': 'canceled_incomplete',
    'Withdrawn': 'withdrawn',
}

export const ALL_DISTRICTS = [
    "ALL",
    "R",
    "M",
    "PDR",
    "RH",
    "RM",
    "RTO",
    "C-3",
    "C",
    "NCT",
    "NC",
    "MIXED-USE",
    "CHINATOWN",
    "MISSION-BAY",
    "MB",
    "DTR",
    "Eastern-Neighborhoods",
    "P",
    "RH-1(D)",
    "RH-1",
    "RH-1(S)",
    "RH-2",
    "RH-3",
    "RM-1",
    "RM-2",
    "RM-3",
    "RM-4",
    "RTO-M",
    "RC-3",
    "RC-4",
    "NC-1",
    "NC-2",
    "NC-3",
    "NC-S",
    "Broadway-NC",
    "Castro-NC",
    "Inner-Clement-NC",
    "Outer-Clement-NC",
    "Excelsior-NC",
    "Upper-Fillmore-NC",
    "Haight-NC",
    "Japantown-NC",
    "North-Beach-NC",
    "Polk-NC",
    "Sacramento-NC",
    "Union-NC",
    "Lakeside-NC",
    "Noe-Valley-NC",
    "West-Portal-NC",
    "Inner-Sunset-NC",
    "Pacific-Ave-NC",
    "Noriega-NC",
    "Irving-NC",
    "Taraval-NC",
    "Judah-NC",
    "Inner-Balboa-NC",
    "Outer-Balboa-NC",
    "Bayview-NC",
    "Cortland-NC",
    "Geary-NC",
    "Mission-Bernal-NC",
    "San-Bruno-NC",
    "Cole-Valley-NC",
    "Lower-Haight-NC",
    "Lower-Polk-NC",
    "Inner-Taraval-NC",
    "NCT-1",
    "NCT-2",
    "NCT-3",
    "Hayes-Gough-NCT",
    "Valencia-NCT",
    "24TH-Mission-NCT",
    "Upper-Market-NCT",
    "Soma-NCT",
    "Mission-NCT",
    "Ocean-NCT",
    "Glen-Park-NCT",
    "Folsom-NCT",
    "Regional-NCT",
    "Divisadero-NCT",
    "Fillmore-NCT",
    "C-2",
    "C-3-O",
    "C-3-O(SD)",
    "C-3-R",
    "C-3-G",
    "C-3-S",
    "M-1",
    "M-2",
    "PDR-1-B",
    "PDR-1-D",
    "PDR-1-G",
    "PDR-2",
    "CCB",
    "CR/NC",
    "CVR",
    "CMUO",
    "MUG",
    "MUO",
    "MUR",
    "RED",
    "RED-MX",
    "SALI",
    "SPD",
    "UMU",
    "WMUG",
    "WMUO",
    "RH-DTR",
    "SB-DTR",
    "TB-DTR",
    "MB-R-1",
    "MB-R-2",
    "MB-R-3",
    "MB-NC-2",
    "MB-NC-3",
    "MB-NC-S",
    "MB-O",
    "MB-CI",
    "MB-H",
    "MB-CF",
    "MB-OS",
]

export const INDIVIDUAL_DISTRICTS = [
    'P',
    'RH-1(D)',
    'RH-1',
    'RH-1(S)',
    'RH-2',
    'RH-3',
    'RM-1',
    'RM-2',
    'RM-3',
    'RM-4',
    'RTO',
    'RTO-M',
    'RC-3',
    'RC-4',
    'NC-1',
    'NC-2',
    'NC-3',
    'NC-S',
    'Broadway-NC',
    'Castro-NC',
    'Inner-Clement-NC',
    'Outer-Clement-NC',
    'Excelsior-NC',
    'Upper-Fillmore-NC',
    'Haight-NC',
    'Japantown-NC',
    'North-Beach-NC',
    'Polk-NC',
    'Sacramento-NC',
    'Union-NC',
    'Lakeside-NC',
    'Noe-Valley-NC',
    'West-Portal-NC',
    'Inner-Sunset-NC',
    'Pacific-Ave-NC',
    'Noriega-NC',
    'Irving-NC',
    'Taraval-NC',
    'Judah-NC',
    'Inner-Balboa-NC',
    'Outer-Balboa-NC',
    'Bayview-NC',
    'Cortland-NC',
    'Geary-NC',
    'Mission-Bernal-NC',
    'San-Bruno-NC',
    'Cole-Valley-NC',
    'Lower-Haight-NC',
    'Lower-Polk-NC',
    'Inner-Taraval-NC',
    'NCT-1',
    'NCT-2',
    'NCT-3',
    'Hayes-Gough-NCT',
    'Valencia-NCT',
    '24TH-Mission-NCT',
    'Upper-Market-NCT',
    'Soma-NCT',
    'Mission-NCT',
    'Ocean-NCT',
    'Glen-Park-NCT',
    'Folsom-NCT',
    'Regional-NCT',
    'Divisadero-NCT',
    'Fillmore-NCT',
    'C-2',
    'C-3-O',
    'C-3-O(SD)',
    'C-3-R',
    'C-3-G',
    'C-3-S',
    'M-1',
    'M-2',
    'PDR-1-B',
    'PDR-1-D',
    'PDR-1-G',
    'PDR-2',
    'CCB',
    'CR/NC',
    'CVR',
    'CMUO',
    'MUG',
    'MUO',
    'MUR',
    'RED',
    'RED-MX',
    'SALI',
    'SPD',
    'UMU',
    'WMUG',
    'WMUO',
    'RH-DTR',
    'SB-DTR',
    'TB-DTR',
    'MB-R-1',
    'MB-R-2',
    'MB-R-3',
    'MB-NC-2',
    'MB-NC-3',
    'MB-NC-S',
    'MB-O',
    'MB-CI',
    'MB-H',
    'MB-CF',
    'MB-OS',
]

export const ALL_SPUDS = [
    "ALL",
    "AUTOMOTIVE",
    "NOB-HILL",
    "WASHINGTON-BROADWAY",
    "WATERFRONT",
    "DOLORES-HEIGHTS",
    "BERNAL-HEIGHTS",
    "VAN-NESS",
    "DOWNTOWN-SUPPORT-OPEN-SPACE-DEMONSTRATION",
    "FOLSOM-AND-MAIN-RESIDENTIAL/COMMERCIAL",
    "THE-VILLAGE",
    "OCEANVIEW-LARGE-RESIDENCE",
    "NORTH-OF-MARKET-RESIDENTIAL",
    "SOUTH-OF-MARKET-HALL-OF-JUSTICE-LEGAL-SERVICES",
    "NON-PROFIT-ARTS-EDUCATION-SPECIAL-USE]",
    "STONESTOWN",
    "1500-MISSION-STREET",
    "GEARY-BOULEVARD/DIVISADERO-STREET",
    "THIRD-STREET",
    "MISSION-AND-9TH-STREET",
    "OAKDALE-AVENUE-AND-QUINT-STREET-AFFORDABLE-HOUSING",
    "THIRD-STREET-AND-ARMSTRONG-AVENUE-AFFORDABLE-HOUSING",
    "NORTHEAST-CHINA-BASIN",
    "NEW-ASIA-SENIOR-AFFORDABLE-HOUSING",
    "GEARY-MASONIC",
    "CALIFORNIA-STREET-AND-PRESIDIO-AVENUE---COMMUNITY-CENTER",
    "FOURTH-AND-FREELON-STREETS",
    "HAIGHT-STREET-SENIOR-AFFORDABLE-HOUSING",
    "JACKSON-SQUARE",
    "ALABAMA-AND-18TH-STREETS-AFFORDABLE-HOUSING",
    "TRANSBAY-C-3",
    "THIRD-STREET-AND-OAKDALE-AVENUE-AFFORDABLE-HOUSING",
    "JAPANTOWN",
    "LAGUNA,-HAIGHT,-BUCHANAN-AND-HERMANN-STREETS",
    "VAN-NESS-&-MARKET-RESIDENTIAL",
    "TRINITY-PLAZA",
    "FRINGE-FINANCIAL-SERVICE-RESTRICTED-USE-DISTRICT",
    "INNOVATIVE-INDUSTRIES",
    "SOMA-YOUTH-AND-FAMILY",
    "WESTERN-SOMA",
    "POTRERO-CENTER-MIXED-USE",
    "901-BUSH-STREET",
    "INDIA-BASIN-INDUSTRIAL-PARK",
    "THIRD-STREET-AND-LE-CONTE-AVENUE-AFFORDABLE-HOUSING",
    "HUNTERS-VIEW",
    "VISITACION-VALLEY/SCHLAGE-LOCK",
    "VETERANS-COMMON",
    "1500-PAGE-STREET-AFFORDABLE-HOUSING",
    "TELEGRAPH-HILL---NORTH-BEACH-RESIDENTIAL",
    "CANDLESTICK-POINT-ACTIVITY-NODE",
    "HUNTERS-POINT-SHIPYARD-PHASE-2",
    "TREASURE-ISLAND/YERBA-BUENA-ISLAND",
    "PRESIDIO-SUTTER",
    "EXECUTIVE-PARK",
    "LOMBARD-AND-SCOTT-STREET-AFFORDABLE-GROUP-HOUSING",
    "CALLE-24",
    "MISSION-ALCOHOLIC-BEVERAGE",
    "17TH-AND-RHODE-ISLAND-STREET-GROCERY-STORE-SPECIAL-USE-SUBDISTRICT",
    "THIRD-STREET-ALCOHOL-RESTRICTED-USE-DISTRICT",
    "CAYUGA/ALEMANY",
    "PARKMERCED",
    "BAYSHORE-BOULEVARD-HOME-IMPROVEMENT",
    "CHINATOWN-TRANSIT-STATION",
    "ART-&-DESIGN-EDUCATIONAL",
    "CESAR-CHAVEZ/VALENCIA-STREETS-MEDICAL-USE",
    "CHINESE-HOSPITAL",
    "YERBA-BUENA-CENTER-MIXED-USE",
    "JEWISH-HOME-OF-SAN-FRANCISCO",
    "FIFTH-AND-MISSION",
    "SUNNYDALE-HOPE-SF",
    "POTRERO-HOPE-SF",
    "CORONA-HEIGHTS-LARGE-RESIDENCE",
    "CENTRAL-SOMA",
    "PIER-70",
    "MISSION-ROCK",
    "1629-MARKET-STREET",
    "430-29TH-AVENUE",
    "INDIA-BASIN",
    "1550-EVANS-AVENUE",
    "3333-CALIFORNIA-STREET",
    "POTRERO-POWER-STATION",
    "BAYVIEW-INDUSTRIAL-TRIANGLE-CANNABIS-RESTRICTED-USE-DISTRICT",
    "2000-MARIN-STREET",
    "BALBOA-RESERVOIR",
    "2500-2530-18TH-STREET-AFFORDABLE-HOUSING",
    "CENTRAL-NEIGHBORHOODS-LARGE-RESIDENCE",
    "GROUP-HOUSING",
    "FAMILY-AND-SENIOR-HOUSING-OPPORTUNITY",
    "900-KEARNY-STREET",
    "WAWONA-STREET-AND-45TH-AVENUE-CULTURAL-CENTER",
    "PRIORITY-EQUITY-GEOGRAPHIES",
    "POTRERO-YARD",
    "30-VAN-NESS-AVENUE",
    "THIRD-STREET-FORMULA-RETAIL-RESTRICTED-USE",
    "GEARY-BOULEVARD-FORMULA-RETAIL-PET-SUPPLY-STORE-AND-FORMULA-RETAIL-EATING-AND-DRINKING",
    "TARAVAL-STREET-RESTAURANT",
]

export const ALL_USES = [
    "ALL",
    "Entertainment, Arts and Recreation",
    "Arts Activities",
    "Entertainment, General",
    "Entertainment, Nighttime",
    "Livery Stable",
    "Movie Theater",
    "Entertainment, Outdoor",
    "Non-Commercial Entertainment and Recreation",
    "Passive Outdoor Recreation",
    "Open Recreation Area",
    "Sports Stadium",
    "Utility and Infrastructure",
    "Community Recycling Collection Center",
    "Internet Service Exchange",
    "Power Plant",
    "Public Transportation Facility",
    "Public Utilities Yard",
    "Wireless Telecommunications Services (WTS) Facility",
    "Utility Installation",
    "Institutional",
    "Institutional Community",
    "Institutional Education",
    "Institutional Healthcare",
    "Child Care Facility",
    "Community Facility",
    "Community Facility, Private",
    "Religious Institution",
    "Job Training",
    "Social Service or Philanthropic Facility",
    "Public Facility",
    "Post-Secondary Educational Institution",
    "School",
    "Trade School",
    "Hospital",
    "Medical Cannabis Dispensary",
    "Residential Care Facility",
    "Residential",
    "Dwelling Unit",
    "Group Housing",
    "Residential Hotel",
    "Senior Housing",
    "Homeless Shelter",
    "Live/Work Unit",
    "Commercial",
    "Agriculture",
    "Agriculture, Urban",
    "Agriculture, Neighborhood",
    "Agriculture, Large-Scale Urban",
    "Agriculture, Industrial",
    "Industrial",
    "Agricultural and Beverage Processing 1",
    "Agricultural and Beverage Processing 2",
    "Automobile Wrecking",
    "Automobile Assembly",
    "Grain Elevator",
    "Hazardous Waste Facility",
    "Junk Yard",
    "Livestock Processing 1",
    "Livestock Processing 2",
    "Manufacturing 1, Heavy",
    "Manufacturing 2, Heavy",
    "Manufacturing 3, Heavy",
    "Manufacturing, Light",
    "Metal Working",
    "Storage Yard",
    "Storage, Volatile Materials",
    "Shipyard",
    "Truck Terminal",
    "Retail Entertainment",
    "Retail",
    "Non-Retail",
    "Sales and Services",
    "Sales and Services, Retail",
    "Eating and Drinking",
    "Bar",
    "Restaurant",
    "Limited Restaurant",
    "Retail Workspace",
    "Adult Sex Venue",
    "Reproductive Health Clinic",
    "Flexible Retail",
    "Flexible Workspace",
    "Adult Business",
    "Animal Hospital",
    "Cannabis Retail",
    "Massage, Chair/Foot",
    "Gift Store-Tourist Oriented",
    "Grocery, General",
    "Grocery, Specialty",
    "Gym",
    "Hotel",
    "Jewelry Store",
    "Kennel",
    "Laundromat",
    "Liquor Store",
    "Massage Establishment",
    "Mortuary",
    "Motel",
    "Pharmacy",
    "Retail Sales and Service, General",
    "Service, Financial",
    "Service, Fringe Financial",
    "Service, Limited Financial",
    "Service, Health",
    "Service, Personal",
    "Service, Retail Professional",
    "Storage, Self",
    "Tobacco Paraphernalia Establishment",
    "Trade Shop",
    "Non-Auto Vehicle Sales or Rental",
    "Sales and Services, Non-Retail",
    "Service, Business",
    "Catering",
    "Storage, Commercial",
    "Design Professional",
    "Office, General",
    "Laboratory",
    "Life Science",
    "Service, Non-Retail Professional",
    "Trade Office",
    "Wholesale Sales",
    "Storage, Wholesale",
    "Automotive",
    "Automotive, Retail",
    "Automotive Repair",
    "Automobile Sale or Rental",
    "Automotive Service Station",
    "Automotive Wash",
    "Electric Vehicle Charging Location",
    "Gas Station",
    "Parking Garage, Public",
    "Parking Lot, Public",
    "Vehicle Storage Garage",
    "Vehicle Storage Lot",
    "Automotive, Non-Retail",
    "Ambulance Service",
    "Fleet Charging",
    "Service, Parcel Delivery",
    "Parking Garage, Private",
    "Parking Lot, Private",
    "Service, Motor Vehicle Tow",
    "Office",
    "Non-Residential",
    "Production, Distribution, and Repair (PDR)",
    "Small Enterprise Workspace (S.E.W.)",
]